var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel__header"},[_c('h2',[_c('i',{staticClass:"panel__header__icon icons icon-people"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.studentName))])])]),_vm._v(" "),_c('div',{staticClass:"panel__body"},[_c('evaluations-table',{attrs:{"onLoaded":_vm.echoName}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56d8b603","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Evaluations.vue
// module id = 772
// module chunks = 5